import React from 'react'
import cn from 'classnames'
import { Button } from '@turretcss/react'

export const SubmitButton = ({ formState, children, className, ...rest }) => {
  if (formState.submitting) children = 'Please wait...'
  if (formState.submitFailed && !formState.modifiedSinceLastSubmit) children = 'Check your details'

  return (
    <Button
      {...rest}
      type="submit"
      className={cn(className, { error: formState.submitFailed && !formState.modifiedSinceLastSubmit })}
      disabled={formState.submitting || (formState.submitFailed && !formState.modifiedSinceLastSubmit)}
      children={children}
    />
  )
}
